var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.905,
    height: 30.466,
    viewBox: "0 0 21.905 30.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M198.985,48.272l1.706-3.376a.716.716,0,0,0-.638-1.039H189.6v-1.14a.717.717,0,0,0-1.434,0V64.333h-4.107a1.85,1.85,0,0,0-1.846,1.86v1.5h-1.222a2.151,2.151,0,0,0-2.129,2.129v1.925a.717.717,0,0,0,.717.717h18.613a.717.717,0,0,0,.717-.717V69.81a2.15,2.15,0,0,0-2.129-2.129h-1.229V66.193a1.85,1.85,0,0,0-1.846-1.846h-4.1V53.111h10.452a.717.717,0,0,0,.652-1.011Z",
    transform: "translate(-178.864 -42)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.be2238cfd02fa2e46b41e0fe01862418.svg";
export { ForwardRef as ReactComponent };